export { default } from './Home24C2C';
